import TableActions from './TableActions';

export default TableActions;
